export { default } from './CallToAction';



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeroIV/CallToAction/index.js